import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import type { SanityPageBuilderSection, SanityPageBuilderTextOnlySection } from "@ouster/shared";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTextOnlySection;
  };
};

// Width variants supported by the text renderer.
const layouts = {
  full: {
    "width": "100%"
  },
  large: {
    "@media (min-width: 1024px)": {
      "marginLeft": "auto",
      "marginRight": "auto",
      "width": "75%"
    }
  },
  medium: {
    "@media (min-width: 1024px)": {
      "marginLeft": "auto",
      "marginRight": "auto",
      "width": "50%"
    }
  }
} as const;
type Layout = keyof typeof layouts;
export function SanityTextOnlySection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  const layout = (sectionContent.layout || "large") as Layout;
  if (!sectionContent.text) {
    return null;
  }
  return <_StyledSection data-theme={mode} id={sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key} data-sanity-section-key={section._key} data-sanity-section-type={section._type} data-anchor-name={sectionSettings?.anchorName} $_css={[sectionSettings?.hasTopDivider && {
    "borderTopWidth": "1px"
  }, themeStyle.text, themeStyle.border, themeStyle.background]}>
      <Wrap mode={mode}>
        <_StyledDiv $_css2={[{
        "position": "relative",
        "zIndex": "10"
      }, themeStyle.background]}>
          <_StyledDiv2 $_css3={[{
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "109.4rem",
          "padding": "4rem",
          "@media (min-width: 1024px)": {
            "paddingTop": "8rem",
            "paddingBottom": "8rem"
          }
        }, layouts[layout]]}>
            <SanityRichText value={sectionContent.text} />
          </_StyledDiv2>
        </_StyledDiv>
      </Wrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-sn1dby-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-sn1dby-1"
})`${p => p.$_css2}`;
var _StyledDiv2 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "text-only___StyledDiv2",
  componentId: "sc-v4p7dm-0"
})(["", ""], p => p.$_css3);